import * as React from 'react'
import {observer} from 'mobx-react'
import {
  EpikQueryParam,
  PaymentCurrency,
  EpmsSubscriptionStatus,
} from '@raisenow/epik'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {WidgetView} from '../../../../lib/WidgetView'
import {formatAmountWithSuffix, subunitsToUnits} from '../../../../lib/helpers'
import {IconHeart} from '../../../ui/Icons'

///////////////////////////////////////////////////////////////////////////////

export const EpmsSubscriptionInfoSubscriptionDetails = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const {epmsSubscriptionInfo, epmsPaymentSourceInfo, computedConfig} = api

  if (!epmsSubscriptionInfo || !epmsPaymentSourceInfo) {
    return null
  }

  const isCancelled =
    epmsSubscriptionInfo.status === EpmsSubscriptionStatus.CANCELLED
  const currency = epmsSubscriptionInfo.currency_identifier as PaymentCurrency
  const amount = subunitsToUnits(
    epmsSubscriptionInfo.amount,
    currency,
    computedConfig,
  )

  // todo: get it from epmsSubscriptionInfo when it will contain custom_paramaters
  let intervalName = api.trans(
    `recurring_intervals.${epmsPaymentSourceInfo.custom_parameters?.rnw_recurring_interval_name}`,
    {defaultValue: null},
  )
  if (intervalName) {
    intervalName = intervalName.toLowerCase()
  }
  const purpose = epmsPaymentSourceInfo.custom_parameters?.rnw_purpose_id

  const cancelSubscription = () => {
    setTimeout(async () => {
      api.epik.updateCurrentUrl({
        params: {
          [EpikQueryParam.VIEW]: WidgetView.SUBSCRIPTION_CANCEL,
        },
      })
      await api.ui.scrollToTop()
      api.ui.focusWidgetElementBySelector(
        '.subscription-cancel .actions .action-back',
      )
    })
  }

  return (
    <section className="subscription-details">
      <div className="header">
        <div className="title">
          <h2 className="text">
            {api.trans(
              'blocks.epms_subscription_info.subscription_details.title',
            )}
          </h2>
          <span className="icon" role="presentation">
            <IconHeart />
          </span>
        </div>
      </div>

      <p className="main">
        {isCancelled && (
          <span className="subscription-inactive">
            {api.trans(
              'blocks.epms_subscription_info.subscription_details.subscription_inactive',
            )}
          </span>
        )}

        <span className="amount-and-recurring-interval">
          <span className="currency">{currency}</span>
          <span className="amount">
            {formatAmountWithSuffix(amount, currency, computedConfig)}
          </span>
          {intervalName && (
            <span className="recurring-interval">/ {intervalName}</span>
          )}
        </span>

        {purpose && (
          <span className="purpose">
            {api.trans(
              'blocks.epms_subscription_info.subscription_details.purpose_prefix',
            )}{' '}
            "{api.trans(`purposes.${purpose}`)}"
          </span>
        )}
      </p>

      {!isCancelled && (
        <div className="actions">
          <button type="button" onClick={cancelSubscription}>
            <span className="link">
              {api.trans(
                'blocks.subscription_info.subscription_details.cancel_subscription',
              )}
            </span>
          </button>
        </div>
      )}
    </section>
  )
})
